export enum ELogoType {
    LIGHT = 0,
    DARK = 1
}

export enum ELogoScaleType {
    SMALL,
    NORMAL,
    LARGE
}
